import React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import styles from "./LegalPages.module.css";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const TermsOfService = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Muigai Medical Center</title>
        <meta
          name="description"
          content="Terms of service for using the Muigai Medical Center website and telemedicine services."
        />
      </Helmet>

      <section className={styles.heroBanner}>
        <div className={styles.heroOverlay}></div>
        <div className="container">
          <motion.div
            className={styles.heroContent}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <motion.div className={styles.sectionTag} variants={fadeInUp}>
              LEGAL
            </motion.div>
            <motion.h1 variants={fadeInUp}>Terms of Service</motion.h1>
            <motion.p className={styles.heroSubtitle} variants={fadeInUp}>
              Please read these terms carefully before using our services.
            </motion.p>
          </motion.div>
        </div>
        <div className={styles.heroBackground}>
          <div
            className={styles.floatingCircle}
            style={{ top: "15%", left: "10%", width: "120px", height: "120px" }}
          />
          <div
            className={styles.floatingCircle}
            style={{
              bottom: "20%",
              right: "15%",
              width: "80px",
              height: "80px",
            }}
          />
          <div
            className={styles.floatingCircle}
            style={{ top: "60%", left: "20%", width: "60px", height: "60px" }}
          />
        </div>
      </section>

      <section className={styles.contentSection}>
        <div className="container">
          <div className={styles.contentCard}>
            <p>
              <strong>Last updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using the Muigai Medical Center website and
              services, you agree to be bound by these Terms of Service. If you
              do not agree, please do not use our services.
            </p>

            <h2>2. Medical Disclaimer</h2>
            <p>
              The information provided on this website is for general
              informational purposes only and is not a substitute for
              professional medical advice, diagnosis, or treatment. Always seek
              the advice of your physician or other qualified health provider
              with any questions you may have regarding a medical condition.
            </p>

            <h2>3. Telemedicine Services</h2>
            <p>
              Our telemedicine consultations are intended for non-emergency
              situations. In case of an emergency, please call emergency
              services immediately. Telemedicine services may not be suitable
              for all conditions, and the final decision on the appropriateness
              of telemedicine lies with the healthcare provider.
            </p>

            <h2>4. Appointment Cancellation</h2>
            <p>
              We require at least 24 hours' notice for cancellation or
              rescheduling of appointments. Failure to cancel may result in a
              cancellation fee.
            </p>

            <h2>5. Intellectual Property</h2>
            <p>
              All content on this website, including text, graphics, logos, and
              images, is the property of Muigai Medical Center and protected by
              copyright laws. You may not reproduce, distribute, or modify any
              content without our prior written consent.
            </p>

            <h2>6. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Muigai Medical Center
              shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages arising out of your use of our
              services or website.
            </p>

            <h2>7. Governing Law</h2>
            <p>
              These terms shall be governed by the laws of Kenya. Any disputes
              arising from these terms shall be resolved in the courts of
              Nairobi.
            </p>

            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes
              will be effective immediately upon posting. Your continued use of
              the services constitutes acceptance of the modified terms.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about these terms, please contact us at
              info@muigaiclinic.com.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfService;
